import { AppointmentActionTypes } from './appointment-action';

export const initialState = {
  userId: undefined,
  selectedServiceTypeId: undefined,
  selectedAddress: null,
  selectedServiceFee: undefined,
  switchToDatePicker: false,
  serviceFeeList: [],
  loadingServiceType: false,
  expandUserAddress: false,
  availableDate: undefined,
  selectedDate: undefined,
  startDate: undefined,
  endDate: undefined,
  serviceTimeSheetAM: [],
  serviceTimeSheetPM: [],
  selectedTime: undefined,
  timeSheetLoading: false,
  dayDateEncrypt: undefined,
};

function appointmentReducer(state = initialState, action: any) {
  switch (action.type) {
    case AppointmentActionTypes.SET_SELECTED_ADDRESS:
      return {
        ...state,
        selectedAddress: action?.data?.addressKey,
      };

    case AppointmentActionTypes.GET_SERVICE_FEE:
      return {
        ...state,
        selectedAddress: action?.data?.addressKey,
        loadingServiceType: true,
      };

    case AppointmentActionTypes.SET_DATE_PICKER:
      return {
        ...state,
        switchToDatePicker: action?.data?.switchToDatePicker,
        timeSheetLoading: true,
      };

    case AppointmentActionTypes.SET_SERVICE_FEE:
      return {
        ...state,
        serviceFeeList: action?.data?.serviceFeeList,
        selectedServiceFee: action?.data?.serviceFeeList[0] || undefined,
        loadingServiceType: false,
      };

    case AppointmentActionTypes.SET_USER_DATA:
      return {
        ...state,
        userId: action?.data?.userId,
        selectedServiceTypeId: action?.data?.selectedServiceTypeId,
        switchToDatePicker: false,
      };

    case AppointmentActionTypes.SET_SELECTED_SERVICE:
      return {
        ...state,
        selectedServiceFee: action?.data?.selectedServiceFee,
      };

    case AppointmentActionTypes.SET_EXPAND_ADDRESS:
      return {
        ...state,
        expandUserAddress: action?.data?.expandUserAddress,
      };

    case AppointmentActionTypes.GET_APPOINTMENT_TIMESHEET:
      return {
        ...state,
        selectedDate: action?.data?.selectedDate,
        selectedTime: initialState.selectedTime,
        timeSheetLoading: true,
      };

    case AppointmentActionTypes.SET_APPOINTMENT_DATE:
      return {
        ...state,
        availableDate: action?.data?.availableDate,
        selectedDate: action?.data?.selectedDate,
        startDate: action?.data?.startDate,
        endDate: action?.data?.endDate,
        timeSheetLoading: true,
      };

    case AppointmentActionTypes.SET_APPOINTMENT_TIMESHEET:
      return {
        ...state,
        serviceTimeSheetAM: action?.data?.serviceTimeSheetAM,
        serviceTimeSheetPM: action?.data?.serviceTimeSheetPM,
        dayDateEncrypt: action?.data?.dayDateEncrypt,
        timeSheetLoading: false,
      };

    case AppointmentActionTypes.SET_TIMESHEET_LOADING:
      return {
        ...state,
        timeSheetLoading: action?.data?.timeSheetLoading || false,
        availableDate: [],
      };

    case AppointmentActionTypes.SET_SELECTED_TIME:
      return {
        ...state,
        selectedTime: action?.data?.selectedTime,
      };

    case AppointmentActionTypes.SET_ADDRESS_MODAL:
      return {
        ...state,
        switchToDatePicker: false,
      };

    default:
      return state;
  }
}

export default appointmentReducer;
